import type { Column } from "@fas/cpa-cabinet-ui/lib/Table/Table.types";
import { useSelector } from "react-redux";
import { getTableFields } from "@fas/cpa-state-manager/services/selectors/table";
import type { UseTableHook } from "@fas/cpa-state-manager/redux/hooks";
import { useTable } from "@fas/cpa-state-manager/redux/hooks";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";

export type UseReportTableHookArgs<C> = {
  tableKey: string;
  columnsMap: Record<string, Column<C>>;
};
export type UseReportTableHook<C> = UseTableHook<string> & {
  isLoading: boolean;
  columns: Column<C>[];
};
export const useReportTable = <C>({
  tableKey,
  columnsMap,
}: UseReportTableHookArgs<C>): UseReportTableHook<C> => {
  const baseProps = useTable(tableKey);
  const fields = useSelector((state) => getTableFields(state, tableKey));
  const isLoadingExport = useSelector((state) =>
    getLoadingState(state, `${tableKey}-export`)
  );
  const columns = Object.keys(columnsMap)
    .filter((key) => fields.includes(key))
    .reduce(
      (acc, key) => [...acc, columnsMap[key]] as Column<C>[],
      [] as Column<C>[]
    );

  const isLoadingTable = baseProps.isLoading || isLoadingExport;
  return {
    ...baseProps,
    columns,
    isLoading: isLoadingTable,
    data: baseProps.isLoading ? [] : baseProps.data,
  };
};
